import React from 'react';
import styled from 'styled-components';

interface ContactUsProps {
    contactHeader: string;
    contactMessage?: any;
}

export const ContactContent: React.FC<ContactUsProps> = ({ contactHeader, contactMessage }) => {
    const ContactHeader = styled.h1`
        font-weight: 300;
        font-size: 32px;
        line-height: 38.4px;
    `;

    const ContactBody = styled.p`
        font-weight: 400;
        font-size: 18px;
        line-height: 20.7px;
        margin-bottom: 32px;
    `;

    const defaultMessage = `A Customer Support Representative is ready to help you by telephone during the weekday business hours in your country. They are also available anytime at <a href='mailto: help@store.ChurchofJesusChrist.org' style={{ textDecoration: 'none', color: '#01B6D1' }}>help@store.ChurchofJesusChrist.org</a>. Please provide your name and order number or magazine subscription account number if applicable. <br /> <br /> If you are looking for contact information for stores in another country, you can change the country contact information below.`;

    const contactBodyText = contactMessage ? contactMessage : defaultMessage;

    return (
        <>
            <ContactHeader>{contactHeader ? contactHeader : 'Contact Us'}</ContactHeader>
            <ContactBody>
                <div dangerouslySetInnerHTML={{ __html: contactBodyText }} />
            </ContactBody>
        </>
    );
};
